export default __webpack_public_path__ + "static/media/ognportfoliofrontpage.9ac61675.jpg";